import { RouteRecordRaw, createRouter, createWebHistory } from "vue-router";

import config from "@/config";
import AssetCreator from "@/pages/AssetCreator.vue";
import FormBuilder from "@/pages/FormBuilder.vue";
import QuizBuilder from "@/pages/QuizBuilder.vue";
import SurveyBuilder from "@/pages/SurveyBuilder.vue";
import { useAppStore } from "@/store/app";
import { h } from "vue";

const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: "/form-builder-v2/:form_id",
    name: "form-builder-v2",
    component: FormBuilder,
  },
  {
    path: "/form-builder-v2/create",
    name: "form-builder-v2-create",
    component: AssetCreator,
    props: (route) => ({ source: route.query.source }),
  },
  {
    path: "/survey-builder-v2/create",
    name: "survey-builder-v2-create",
    component: AssetCreator,
    props: (route) => ({ source: route.query.source }),
  },
  {
    path: "/quiz-builder-v2/create",
    name: "quiz-builder-v2-create",
    component: AssetCreator,
    props: (route) => ({ source: route.query.source }),
  },
  {
    path: "/survey-builder-v2/:survey_id",
    name: "survey-builder-v2",
    component: SurveyBuilder,
  },
  {
    path: "/quiz-builder-v2/:quiz_id",
    name: "quiz-builder-v2",
    component: QuizBuilder,
  },
  {
    path: "/contact-detail-v2/:contact_id",
    name: "contact_detail-v2",
    component: () => h("div"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  if (to.name === "contact_detail-v2") {
    const contactIdParam = to.params?.contact_id;
    const contactId = Array.isArray(contactIdParam) ? contactIdParam[0] : contactIdParam;
    if (!contactId || typeof contactId !== "string") {
      return false;
    }

    const appStore = useAppStore();
    const baseUrl = `${config.mode === "dev" ? "http" : "https"}://${
      appStore.company.domain || config.GHL_DOMAIN
    }`;
    const url = `${baseUrl}/v2/location/${appStore.locationId}/contacts/detail/${contactId}`;
    window.open(url, "_blank");
    return false;
  }
  return true;
});

export { router };
